import React, { Component } from "react";
import {
  FormControl,
  FormGroup,
  HelpBlock,
  InputGroup,
  Checkbox,
} from "react-bootstrap";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import Select from "react-select";
import DropzoneComponent from "react-dropzone-component";
import MaskedFormControl from "react-bootstrap-maskedinput";
import {
  MultiSelectComponent,
  CheckBoxSelection,
  Inject,
} from "@syncfusion/ej2-react-dropdowns";
import ReactQuill from "react-quill";
import _ from "lodash";
import "react-quill/dist/quill.snow.css";
import FormLabel from "../FormLabel/FormLabel";
import "./FormInput.css";
import { numberFormat } from "../../lib/Formatter";

class FormInput extends Component {
  state = {
    value: "",
    multiSelectValue: [],
    dropZone: null,
    djsConfig: {
      addRemoveLinks: true,
      acceptedFiles: "",
      autoProcessQueue: false,
      maxFiles: 0,
      dictDefaultMessage: "Click here or drag files to upload",
    },
    componentConfig: {
      allowedFiletypes: [],
      showFiletypeIcon: true,
      postUrl: "no-url",
    },
  };

  componentDidMount() {
    if (this.props.type === "fileDrop") {
      let base_url = process.env.REACT_APP_WEBAPI_BASE;
      let acceptedFiles =
        "image/jpeg,image/png,image/gif,application/pdf,text/plain,application/zip";
      let allowedFiletypes = [
        ".jpg",
        ".png",
        ".gif",
        ".pdf",
        ".txt",
        ".zip",
        ".jpeg",
      ];
      let maxFiles = 10;

      if (process.env.REACT_APP_ENV === "staging") {
        base_url = process.env.REACT_APP_WEBAPI_STAGING;
      } else if (process.env.REACT_APP_ENV === "test") {
        base_url = process.env.REACT_APP_WEBAPI_TEST;
      } else if (process.env.REACT_APP_ENV === "production") {
        base_url = process.env.REACT_APP_WEBAPI_PRODUCTION;
      }

      if (this.props.acceptedFiles != null) {
        acceptedFiles = this.props.acceptedFiles;
      }
      if (this.props.allowedFiletypes != null) {
        allowedFiletypes = this.props.allowedFiletypes;
      }
      if (this.props.maxFiles != null) {
        maxFiles = this.props.maxFiles;
      }

      let postUrl = (base_url += !_.isEmpty(this.props.postUrl)
        ? this.props.postUrl
        : "no-url");

      this.setState({
        djsConfig: {
          ...this.state.djsConfig,
          headers: {
            Authorization: `Bearer ${this.props.accessToken}`,
          },
          acceptedFiles: acceptedFiles,
          maxFiles: maxFiles,
        },
        componentConfig: {
          ...this.state.componentConfig,
          postUrl: postUrl,
          allowedFiletypes: allowedFiletypes,
        },
      });
    } else if (this.props.type !== "multiselect") {
      this.setState({ value: this.props.value });
    } else {
      this.setState({ multiSelectValue: this.props.value });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.processQueue !== this.props.processQueue &&
      this.props.processQueue === true
    ) {
      this.dropZone.processQueue();
    }

    if (this.props.type === "multiselect") {
      let multiSelectValue = [...this.state.multiSelectValue];
      if (prevProps.selectAllOptions !== this.props.selectAllOptions) {
        if (this.props.selectAllOptions === true) {
          let selectedValues = this.props.children.map((o) => {
            return o.props.value;
          });
          selectedValues = selectedValues.filter(
            (s) => !multiSelectValue.includes(s),
          );
          if (selectedValues && selectedValues.length > 0) {
            this.setState({
              multiSelectValue: [...multiSelectValue, ...selectedValues],
            });
          }
        } else {
          if (multiSelectValue.length > 0 && this.props.value.length <= 0)
            this.setState({ multiSelectValue: [] });
        }
      } else {
        if (multiSelectValue.length !== this.props.value.length)
          this.setState({ multiSelectValue: [] });
      }
    }
    // Update state value when props change (for html editor)
    if (this.props.type === "html" && prevProps.value !== this.props.value) {
      this.setState({ value: this.props.value });
    }
  }

  uploadQueueCompleteHandler = () => {
    this.dropZone.removeAllFiles();

    if (this.props.queueCompleted) {
      this.props.queueCompleted();
    }
  };

  uploadFileCompleteHandler = (file, response) => {
    if (this.props.fileCompleted) {
      this.props.fileCompleted(file, response);
    }
  };

  maxFilesReachedHandler = () => {
    if (this.props.showMaxFilesReached) {
      if (this.props.uploadeError) {
        this.props.uploadError(
          <span>You have reached the max number of files.</span>,
        );
      }
    }
  };

  maxFilesExceededHandler = () => {
    if (this.props.uploadeError) {
      this.props.uploadError(
        <span>You have exceeded the maximum allowed files to upload.</span>,
      );
    }
  };

  uploadErrorHandler = () => {
    if (this.props.uploadeError) {
      this.props.uploadError(
        <span>
          An error was encountered while trying to upload one of the files.
        </span>,
      );
    }
  };

  inputChangedHandler = (event) => {
    let id = "";
    let value = null;

    if (this.props.type === "multilineselect") {
      id = this.props.id;
      value = event.value;
    } else if (this.props.type === "html") {
      id = this.props.id;
      value = event;
    } else if (this.props.type === "multiselectsf") {
      id = event.element.id;
      value = event.value;
    } else if (this.props.type === "typeahead") {
      if (event && event.length > 0) {
        id = this.props.id;
        value = event[0].id;
      }
    } else {
      id = event.target.id;
      value = event.target.value;
    }

    if (this.props.type === "multiselectsf") {
      if (this.state.value !== value) {
        this.setState({ value: value });
      }
    } else if (this.props.type === "multilineselect") {
      this.setState({ value: value });
    } else if (this.props.type === "multiselect") {
      let multiValues = this.state.multiSelectValue.slice();

      if (!Array.isArray(multiValues)) {
        multiValues =
          this.state.multiSelectValue === undefined ||
          this.state.multiSelectValue === null
            ? []
            : [this.state.multiSelectValue];
      }

      const selected = multiValues.find((multiValue) => {
        return multiValue.toString() === value.toString();
      });

      if (selected === undefined && event.target.checked) {
        multiValues.push(parseInt(value.toString()));
      } else if (selected && !event.target.checked) {
        const values = multiValues.map(String);
        const index = values.indexOf(value.toString());

        if (index > -1) {
          multiValues.splice(index, 1);
        }
      }

      this.setState({ multiSelectValue: multiValues });

      id = this.props.id;
      value = multiValues;
    } else {
      this.setState({ value: value });
    }

    if (this.props.type === "money") {
      value = numberFormat(value);
      this.props.changed(id, value);
    }
    if (this.props.changed) {
      this.props.changed(id, value);
    }
  };

  checkboxClickHandler(id, _event) {
    if (this.props.changed) {
      this.props.changed(id, !this.props.value);
    }
  }

  customOption = (props) => {
    const { innerProps, innerRef } = props;

    let className = "multiline-select-option";
    if (props.isFocused) {
      className += " multiline-select-option-focused";
    }

    return (
      <div ref={innerRef} {...innerProps} className={className}>
        <strong>{props.data.label}</strong>
        <p style={{ color: "#898989" }}>{props.data.description}</p>
      </div>
    );
  };

  render() {
    let {
      required,
      helpText,
      labelSubText,
      labelText,
      changed,
      errorMessage,
      mask,
      prefix,
      postfix,
      fields,
      dataSource,
      groupTemplate,
      placeholder,
      paramid,
      sfvalue,
      options,
      searchHandler,
      ...controlProps
    } = this.props;

    let hasError = !_.isEmpty(errorMessage);

    const labelProps = {
      required: required,
      helpText: helpText,
      labelSubText: labelSubText,
      hasError: hasError,
    };

    let control = null;

    switch (this.props.type) {
      case "fileDrop": {
        const eventHandlers = {
          init: (dz) => (this.dropZone = dz),
          queuecomplete: () => this.uploadQueueCompleteHandler(),
          success: (file, response) =>
            this.uploadFileCompleteHandler(file, response),
          maxfilesreached: () => this.maxFilesReachedHandler(),
          maxfilesexceeded: () => this.maxFilesExceededHandler(),
          error: () => this.uploadErrorHandler(),
        };

        control = (
          <div className="file-uploader">
            <DropzoneComponent
              config={this.state.componentConfig}
              eventHandlers={eventHandlers}
              djsConfig={this.state.djsConfig}
            />
          </div>
        );
        break;
      }
      case "checkbox": {
        const classType = hasError ? "form-checkbox-error" : "";
        const visible = this.props.value ? 1 : 0;
        const { id } = controlProps;
        const disabled = controlProps.disabled && { disabled: true };
        const classChecked = this.props.value ? "form-checkbox-checked" : "";

        control = (
          <div
            style={{
              paddingBottom: "2px",
              display: "flex",
              alignItems: "flex-start",
            }}
          >
            <label
              className={`form-checkbox ${classType} ${classChecked}`}
              {...disabled}
              onClick={(event) => this.checkboxClickHandler(id, event)}
            >
              <input id={id} type="hidden" value={this.props.value} />
              <span
                className="glyphicon glyphicon-ok"
                style={{ opacity: visible }}
              ></span>
            </label>
            <span style={{ marginLeft: "5px", fontWeight: "bold", cursor: "pointer" }}
              onClick={(event) => this.checkboxClickHandler(id, event)}>
              {labelText}
            </span>
          </div>
        );
        break;
      }
      case "multiselect": {
        const label = labelText && (
          <FormLabel {...labelProps}>{labelText}</FormLabel>
        );
        let options = [];

        this.props.children.forEach((option) => {
          let checked = null;
          let disabled = null;

          if (this.props.value) {
            checked = this.props.value.includes(option.props.value)
              ? { checked: true }
              : null;
            disabled = Boolean(this.props.disableAllOptions)
              ? this.props.disableAllOptions
                ? { disabled: true }
                : null
              : !this.props.value.includes(option.props.value) &&
                  option.props.disabled
                ? { disabled: true }
                : null;
            options.push(
              <Checkbox
                key={option.props.value}
                value={option.props.value}
                {...checked}
                {...disabled}
                onChange={(event) => this.inputChangedHandler(event)}
              >
                {option.props.children}
              </Checkbox>,
            );
          }
        });

        if (options == null || options.length < 1) {
          const noOptionsText = this.props.noOptionsText
            ? this.props.noOptionsText
            : "No selectable options available.";

          options = (
            <div
              style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {noOptionsText}
            </div>
          );
        }

        control = (
          <React.Fragment>
            {label}
            <div
              style={{
                height: "100px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                padding: "0 10px",
                overflowY: "scroll",
              }}
            >
              {options}
            </div>
          </React.Fragment>
        );
        break;
      }
      case "multiselectsf": {
        const label = labelText && (
          <FormLabel {...labelProps}>{labelText}</FormLabel>
        );

        control = (
          <React.Fragment>
            {label}
            <MultiSelectComponent
              id={paramid}
              dataSource={dataSource}
              groupTemplate={groupTemplate}
              fields={fields}
              placeholder={placeholder}
              value={sfvalue}
              mode="CheckBox"
              selectAllText="Select All"
              unSelectAllText="Unselect All"
              showSelectAll={true}
              popupWidth="500px"
              change={(event) => this.inputChangedHandler(event)}
            >
              <Inject services={[CheckBoxSelection]} />
            </MultiSelectComponent>
            {hasError && (
              <HelpBlock>
                <i className="fa fa-exclamation-circle"></i>&nbsp;{errorMessage}
              </HelpBlock>
            )}
          </React.Fragment>
        );
        break;
      }
      case "typeahead": {
        const groupProps = {
          validationState: hasError ? "error" : null,
        };

        const label = labelText && (
          <FormLabel {...labelProps}>{labelText}</FormLabel>
        );

        control = (
          <FormGroup {...groupProps}>
            {label}
            <AsyncTypeahead
              id={this.props.id}
              allowNew={false}
              multiple={false}
              paginate={false}
              labelKey={this.props.labelKey}
              options={this.props.searchOptions}
              isLoading={this.props.isLoading}
              minLength={this.minLength || 3}
              onSearch={(query) => searchHandler(query)}
              onChange={(event) => this.inputChangedHandler(event)}
              placeholder={this.placeholder}
            />
          </FormGroup>
        );
        break;
      }
      case "html":
        const modules = {
          toolbar: [
              [
                { font: [] },
                { header: [1, 2, 3, 4, 5, 6, false] },
                { size: ["small", false, "large", "huge"] },
              ],
              ["bold", "italic", "underline", "strike", "blockquote"],
              [{ background: [] }, { color: [] }],
              [{ align: [] }],
              [
                { list: "ordered" },
                { list: "bullet" },
                { indent: "-1" },
                { indent: "+1" },
              ],
              ["link", "image", "video"],
              ["clean"],
            ],
        };

        const formats = [
          "font",
          "header",
          "size",
          "bold",
          "italic",
          "underline",
          "strike",
          "blockquote",
          "align",
          "background",
          "color",
          "list",
          "bullet",
          "indent",
          "link",
          "image",
          "video",
        ];

        const groupProps = {
          validationState: hasError ? "error" : null,
        };

        control = (
            <FormGroup {...groupProps}>
              {labelText && <FormLabel {...labelProps}>{labelText}</FormLabel>}

              <ReactQuill
                readOnly={controlProps.disabled}
                modules={modules}
                formats={formats}
                value={this.state.value || ""}
                onChange={(event) => this.inputChangedHandler(event)}
              />
              {hasError && <FormControl.Feedback />}
              {hasError && (
                <HelpBlock>
                  <i className="fa fa-exclamation-circle"></i>&nbsp;
                  {errorMessage}
                </HelpBlock>
              )}
            </FormGroup>
        );
        break;
      case "money": {
        const label = labelText && (
          <FormLabel {...labelProps}>{labelText}</FormLabel>
        );
        const groupProps = {
          validationState: hasError ? "error" : null,
        };

        const helpBlock = hasError && (
          <HelpBlock>
            <i className="fa fa-exclamation-circle"></i>&nbsp;{errorMessage}
          </HelpBlock>
        );
        let inputControl = (
          <FormControl
            {...controlProps}
            onChange={(event) => this.inputChangedHandler(event)}
          />
        );

        if (prefix || postfix) {
          const prefixControl = prefix && (
            <InputGroup.Addon>{prefix}</InputGroup.Addon>
          );
          const postfixControl = postfix && (
            <InputGroup.Addon>{postfix}</InputGroup.Addon>
          );

          inputControl = (
            <InputGroup>
              {prefixControl}
              {inputControl}
              {postfixControl}
            </InputGroup>
          );
        }

        control = (
          <FormGroup {...groupProps}>
            {label}
            {inputControl}
            {helpBlock}
          </FormGroup>
        );
        break;
      }
      case "multilineselect":
      case "select":
      default: {
        const label = labelText && (
          <FormLabel {...labelProps}>{labelText}</FormLabel>
        );

        const feedback = hasError && <FormControl.Feedback />;
        const helpBlock = hasError && (
          <HelpBlock>
            <i className="fa fa-exclamation-circle"></i>&nbsp;{errorMessage}
          </HelpBlock>
        );

        const groupProps = {
          validationState: hasError ? "error" : null,
        };

        const selectProps = this.props.type === "select" && {
          componentClass: "select",
        };
        const textAreaProps = this.props.type === "textarea" && {
          componentClass: "textarea",
        };

        let inputControl = null;

        if (this.props.type !== "multilineselect") {
          if (this.props.type === "date") {
            controlProps = { ...controlProps, max: "9999-12-31" };
          }
          inputControl = mask ? (
            <MaskedFormControl
              {...controlProps}
              onChange={(event) => this.inputChangedHandler(event)}
              mask={mask}
            />
          ) : (
            <FormControl
              {...controlProps}
              {...selectProps}
              {...textAreaProps}
              onChange={(event) => this.inputChangedHandler(event)}
            />
          );
        } else {
          if (options) {
            const customOptions = options.map((option) => {
              return {
                value: option.id,
                label: option.name,
                description: option.description,
              };
            });

            inputControl = (
              <Select
                options={customOptions}
                components={{ Option: this.customOption }}
                onChange={(event) => this.inputChangedHandler(event)}
              />
            );
          }
        }

        if (prefix || postfix) {
          const prefixControl = prefix && (
            <InputGroup.Addon>{prefix}</InputGroup.Addon>
          );
          const postfixControl = postfix && (
            <InputGroup.Addon>{postfix}</InputGroup.Addon>
          );

          inputControl = (
            <InputGroup>
              {prefixControl}
              {inputControl}
              {postfixControl}
            </InputGroup>
          );
        }

        control = (
          <FormGroup {...groupProps}>
            {label}
            {inputControl}
            {feedback}
            {helpBlock}
          </FormGroup>
        );
        break;
      }
    }

    return <React.Fragment>{control}</React.Fragment>;
  }
}

export default FormInput;
